import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { useActivationGate } from '../activationGateHooks';
import { ActivationGateTab } from '../tabs/ActivationGateTab';
export function ActivationGatePage() {
    const { programId } = useProgramContext();
    // Direct-upload programs have no gate (only CommitImport seeds one) and no
    // nav item — a direct URL / stale bookmark goes home instead of rendering
    // an empty shell. Resolved-null only: loading renders the tab's own loading
    // state, and errors keep the tab's error copy.
    const { data: gate, isLoading } = useActivationGate(programId);
    if (!isLoading && gate === null) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: `/delivery/programs/${programId}`,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(ActivationGateTab, {
            contractProjectId: programId
        })
    });
}
